import Button from '../../../../shared/Button';
import FocusTrap from '../../../../shared/FocusTrap';
import Icon from '@showclix-shared/Icon';
import clsx from 'clsx';
import { createContext, useContext, useEffect, useMemo, useRef } from 'react';

const CheckoutModalContext = createContext();

const Modal = ({ open, onClose: onCloseProp, children, backdrop = false, focusTrapOptions = {} }) => {
  const id = useRef(new Date().getTime()).current;

  const onClose = useMemo(() => onCloseProp, [onCloseProp]);

  useEffect(() => {
    const action = open ? 'add' : 'remove';
    document.body.classList[action]('no-scroll');
  }, [open]);

  useEffect(() => {
    // Clean up just in case
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <CheckoutModalContext.Provider value={{ onClose, id }}>
      <FocusTrap
        fallback={'.checkout-modal__container'}
        focusTrapOptions={focusTrapOptions}
      >
        <div className={clsx('checkout-modal__container', { 'checkout-modal__container--backdrop': backdrop })}>
          <dialog
            id={`checkout-modal-${id}`}
            className="checkout-modal"
            aria-modal="true"
            aria-labelledby={`checkout-modal-title-${id}`}
          >
            {children}
          </dialog>
        </div>
      </FocusTrap>
    </CheckoutModalContext.Provider>
  );
};

const Header = ({ children }) => <header className="checkout-modal__header">{children}</header>;

const Title = ({ children }) => {
  const { id } = useContext(CheckoutModalContext);

  return <h2 id={`checkout-modal-title-${id}`}>{children}</h2>;
};

const Close = (props) => {
  const { onClose } = useContext(CheckoutModalContext);

  return (
    <Button {...props} className="button--clear checkout-modal__icon-button" onClick={onClose}>
      <Icon icon="icon-close" size={20} color="#000" alt="Close modal" />
    </Button>
  );
};

const Body = ({ children, padding = 'lg' }) => (
  <main className={clsx('checkout-modal__main', `checkout-modal__main--padding-${padding}`)}>{children}</main>
);

const Footer = ({ children }) => <footer className="checkout-modal__footer">{children}</footer>;

export const CheckoutModal = Object.assign(Modal, {
  Header,
  Title,
  Body,
  Footer,
  CloseButton: Close,
});
